
const Phone = (string: string, ddi: boolean) => {
    if (!string) {
        return '';
    }

    string = string.replace(/\D/g, '');

    if (ddi) {
        string = string.replace(/^(\d{2})(\d{2})(\d)/, "+$1 $2 $3");
    } else {
        string = string.replace(/^(\d{2})(\d)/, "($1) $2");
    }

    string = string.replace(/(\d)(\d{4})$/, "$1-$2");
    return string;
}


const Money = (
    value: number, 
    locale: string = 'pt-BR', 
    options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: 'BRL'
    }
) => {
    const moneyFormat = new Intl.NumberFormat(locale, options);

    return moneyFormat.format(value);
}


const MaskHelper = {
    Phone,
    Money
};

export default MaskHelper;